import TextInputField from "../components/TextInputField";
import SelectField from "../components/SelectField";
import DoubleField from "../components/DoubleField";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { Col, Row } from "react-bootstrap";

const PosForm2 = ({
  formData,
  partData,
  errors = [],
  currentColor,
  CustomerOptions,
  termsOptions,
  poAddressOptions,
  loadOptions,
  type,
  handleChange,
  handleSelectChange,
  handleRadioChange,
  handleCopyClick,
  handleAddcartClick,
  viewOnly = false,
}) => {
  function handleRadioBtnChange(event) {
    handleRadioChange(event.target.value);
  }

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  const hasAnyValue = (obj) => {
    return Object.values(obj).some((innerObj) => {
      return Object.keys(innerObj).length > 0;
    });
  };

  return (
    <div>
      <form>
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          {(type === "sale" || type === "quote") && (
            <>
              <Col md={viewOnly ? 6 : 4} xl={7} className="container-col">
                <label className="label" htmlFor="customer">
                  Customer:
                </label>
                {!viewOnly ? (
                  <SelectField
                    formField={false}
                    name="customer"
                    value={formData.customer}
                    options={CustomerOptions}
                    onChange={handleSelectChange}
                    placeholder="Select Customer"
                    error={errors.customer}
                    autoFocus
                  />
                ) : (
                  <input
                    className={"input input-full"}
                    name="customer"
                    value={formData.customer.label || `-`}
                    placeholder="Customer"
                    disabled={viewOnly}
                  />
                )}
              </Col>
              {!viewOnly && (
                <Col md={2} xl={1}>
                  <div
                    className="sale-bal mt-6"
                    style={{ backgroundColor: currentColor, color: "white" }}
                  >
                    <label>
                      {formatCurrency(formData.customer?.balance ?? 0)}
                    </label>
                  </div>
                </Col>
              )}
              <Col md={3} xl={viewOnly ? 3 : 2} className="container-col">
                <label className="label">Cust PO:</label>
                <input
                  type="text"
                  className={"input input-full"}
                  name="customer_po"
                  value={formData.customer_po}
                  onChange={handleChange}
                  placeholder="Customer PO"
                  error={errors.customer_po}
                  disabled={viewOnly}
                />
                {errors.customer_po && (
                  <p className="label-error-pos">{errors.customer_po}</p>
                )}
              </Col>
            </>
          )}
          {type === "purchase" && (
            <>
              <Col
                md={viewOnly ? 6 : 3}
                xl={viewOnly ? 7 : 5}
                className="container-col"
              >
                <label className="label" htmlFor="vendor">
                  Vendor:
                </label>
                {!viewOnly ? (
                  <SelectField
                    formField={false}
                    name="vendor"
                    value={formData.vendor}
                    options={CustomerOptions}
                    onChange={handleSelectChange}
                    placeholder="Select Vendor"
                    error={errors.vendor}
                    autoFocus
                    isDisabled={viewOnly}
                  />
                ) : (
                  <input
                    className={"input input-full"}
                    name="vendor"
                    value={formData.vendor.label || `-`}
                    placeholder="Vendor"
                    disabled={viewOnly}
                  />
                )}
              </Col>
              {!viewOnly && (
                <Col md={2} xl={1}>
                  <div
                    className="sale-bal mt-6"
                    style={{ backgroundColor: currentColor, color: "white" }}
                  >
                    <label>
                      {formatCurrency(formData.vendor?.balance ?? 0)}
                    </label>
                  </div>
                </Col>
              )}
              <Col
                md={viewOnly ? 3 : 2}
                xl={viewOnly ? 3 : 2}
                className="container-col"
              >
                <label className="label">Vendor Inv#:</label>
                <input
                  type="text"
                  className={"input input-full"}
                  name="vendor_invoice_no"
                  value={formData.vendor_invoice_no}
                  onChange={handleChange}
                  placeholder="Vendor Inv#"
                  error={errors.vendor_invoice_no}
                  disabled={viewOnly}
                />
                {errors.vendor_invoice_no && (
                  <p className="label-error-pos">{errors.vendor_invoice_no}</p>
                )}
              </Col>
            </>
          )}
          <Col md={3} xl={2} className="container-col">
            <label className="label" htmlFor="terms">
              Terms:
            </label>
            {!viewOnly ? (
              <SelectField
                formField={false}
                name="terms"
                value={formData.terms}
                options={termsOptions}
                onChange={handleSelectChange}
                placeholder="Select Terms"
                error={errors.terms}
                isDisabled={viewOnly}
              />
            ) : (
              <input
                className={"input input-full"}
                name="terms"
                value={formData.terms.label || `-`}
                placeholder="Terms"
                disabled={viewOnly}
              />
            )}
          </Col>

          {!viewOnly && (
            <>
              {type === "purchase" && (
                <Col md={2} xl={2} className="container-col">
                  <label className="label" htmlFor="po_address">
                    Saved Addr:
                  </label>
                  <SelectField
                    formField={false}
                    name="po_address"
                    value={formData.po_address}
                    options={poAddressOptions}
                    onChange={handleSelectChange}
                    placeholder="Select Address"
                    error={errors.po_address}
                    isDisabled={viewOnly}
                  />
                </Col>
              )}
            </>
          )}

          {(type === "sale" || type === "quote") && (
            <>
              <Col md={2}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Bill To:"
                  name="b_to"
                  value={formData.b_to}
                  onChange={handleChange}
                  placeholder="Bill To Name"
                  error={errors.b_to}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={2}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Bill Street:"
                  name="b_street"
                  value={formData.b_street}
                  onChange={handleChange}
                  placeholder="Billing Street"
                  error={errors.b_street}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={1}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="City:"
                  name="b_city"
                  value={formData.b_city}
                  onChange={handleChange}
                  placeholder="Billing City"
                  error={errors.b_city}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={2}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Bill State:"
                  name="b_state"
                  value={formData.b_state}
                  onChange={handleChange}
                  placeholder="Billing State"
                  error={errors.b_state}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={1}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Zip:"
                  name="b_zip"
                  value={formData.b_zip}
                  onChange={handleChange}
                  placeholder="Billing Zip"
                  error={errors.b_zip}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={2}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Bill Country:"
                  name="b_country"
                  value={formData.b_country}
                  onChange={handleChange}
                  placeholder="Billing Country"
                  error={errors.b_country}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={2}>
                {!viewOnly ? (
                  <div className="article-container-cus1">
                    <div className="article-cu3">
                      <TextInputField
                        formField={false}
                        posField={true}
                        label="Bill Phone:"
                        name="b_phone2"
                        value={formData.b_phone2}
                        onChange={handleChange}
                        placeholder="Billing Phone 2"
                        error={errors.b_phone2}
                      />
                    </div>
                    <div className="article-cu2 ml-1 mt-2">
                      <button
                        style={{
                          fontSize: "12px",
                          padding: "4px",
                          backgroundColor: currentColor,
                          color: "#fff",
                          border: "none",
                          fontWeight: "bold",
                          width: "24px",
                          borderRadius: "4px",
                        }}
                        color="white"
                        onClick={handleCopyClick}
                      >
                        C
                      </button>
                    </div>
                  </div>
                ) : (
                  <TextInputField
                    formField={false}
                    name="b_phone2"
                    value={formData.b_phone2}
                    onChange={handleChange}
                    placeholder="Billing Phone 2"
                    error={errors.b_phone2}
                    disabled={viewOnly}
                  />
                )}
              </Col>
            </>
          )}
          {type === "purchase" && (
            <>
              <Col md={2}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Remit To:"
                  name="r_to"
                  value={formData.r_to}
                  onChange={handleChange}
                  placeholder="Remit To Name"
                  error={errors.r_to}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={2}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Remit Street:"
                  name="r_street"
                  value={formData.r_street}
                  onChange={handleChange}
                  placeholder="Remitting Street"
                  error={errors.r_street}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={1}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="City:"
                  name="r_city"
                  value={formData.r_city}
                  onChange={handleChange}
                  placeholder="Remitting City"
                  error={errors.r_city}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={2}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Remit State:"
                  name="r_state"
                  value={formData.r_state}
                  onChange={handleChange}
                  placeholder="Remitting State"
                  error={errors.r_state}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={1}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Zip:"
                  name="r_zip"
                  value={formData.r_zip}
                  onChange={handleChange}
                  placeholder="Remitting Zip"
                  error={errors.r_zip}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={2}>
                <TextInputField
                  formField={false}
                  posField={true}
                  label="Remit Country:"
                  name="r_country"
                  value={formData.r_country}
                  onChange={handleChange}
                  placeholder="Remitting Country"
                  error={errors.r_country}
                  disabled={viewOnly}
                />
              </Col>
              <Col md={2}>
                {!viewOnly ? (
                  <div className="article-container-cus1">
                    <div className="article-cu3">
                      <TextInputField
                        formField={false}
                        posField={true}
                        label="Remit Phone:"
                        name="r_phone"
                        value={formData.r_phone}
                        onChange={handleChange}
                        placeholder="Remitting Phone"
                        error={errors.r_phone}
                      />
                    </div>
                    <div className="article-cu2 ml-1 mt-2">
                      <button
                        style={{
                          fontSize: "12px",
                          padding: "4px",
                          backgroundColor: currentColor,
                          color: "#fff",
                          border: "none",
                          fontWeight: "bold",
                          width: "24px",
                          borderRadius: "4px",
                        }}
                        color="white"
                        onClick={handleCopyClick}
                      >
                        C
                      </button>
                    </div>
                  </div>
                ) : (
                  <TextInputField
                    formField={false}
                    name="r_phone"
                    value={formData.r_phone}
                    onChange={handleChange}
                    placeholder="Remitting Phone"
                    error={errors.r_phone}
                    disabled={viewOnly}
                  />
                )}
              </Col>
            </>
          )}
          <Col md={2}>
            <TextInputField
              formField={false}
              posField={true}
              label="Ship To:"
              name="s_to"
              value={formData.s_to}
              onChange={handleChange}
              placeholder="Ship To Name"
              error={errors.s_to}
              disabled={viewOnly}
            />
          </Col>
          <Col md={2}>
            <TextInputField
              formField={false}
              posField={true}
              label="Ship Street:"
              name="s_street"
              value={formData.s_street}
              onChange={handleChange}
              placeholder="Shipping Street"
              error={errors.s_street}
              disabled={viewOnly}
            />
          </Col>
          <Col md={1}>
            <TextInputField
              formField={false}
              posField={true}
              label="City:"
              name="s_city"
              value={formData.s_city}
              onChange={handleChange}
              placeholder="Shipping City"
              error={errors.s_city}
              disabled={viewOnly}
            />
          </Col>
          <Col md={2}>
            <TextInputField
              formField={false}
              posField={true}
              label="Shipping State:"
              name="s_state"
              value={formData.s_state}
              onChange={handleChange}
              placeholder="Shipping State"
              error={errors.s_state}
              disabled={viewOnly}
            />
          </Col>
          <Col md={1}>
            <TextInputField
              formField={false}
              posField={true}
              label="Zip:"
              name="s_zip"
              value={formData.s_zip}
              onChange={handleChange}
              placeholder="Shipping Zip"
              error={errors.s_zip}
              disabled={viewOnly}
            />
          </Col>
          <Col md={2}>
            <TextInputField
              formField={false}
              posField={true}
              label="Ship Country:"
              name="s_country"
              value={formData.s_country}
              onChange={handleChange}
              placeholder="Shipping Country"
              error={errors.s_country}
              disabled={viewOnly}
            />
          </Col>
          <Col md={2}>
            <TextInputField
              formField={false}
              posField={true}
              label="Ship Phone:"
              name="s_phone"
              value={formData.s_phone}
              onChange={handleChange}
              placeholder="Shipping Phone"
              error={errors.s_phone}
              disabled={viewOnly}
            />
          </Col>
        </Row>
      </form>
      {viewOnly ? (
        <div style={{ marginTop: "24px" }} />
      ) : (
        <>
          <div style={{ marginTop: !hasAnyValue(errors) ? "12px" : "6px" }} />
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            {(type === "sale" || type === "quote") && (
              <Col md={7}>
                <label className="label" htmlFor="part">
                  {partData.type === "part" && <span>Part:</span>}
                  {partData.type === "ncp" && <span>Non Child Part:</span>}
                  {partData.type === "np" && <span>Non Part:</span>}
                  <span
                    style={{
                      float: "right",
                      paddingRight: "4%",
                      fontWeight: "normal",
                    }}
                  >
                    <label>
                      <input
                        type="radio"
                        name="kind"
                        value="part"
                        id="part"
                        onChange={handleRadioBtnChange}
                        style={{
                          width: "12px",
                          height: "12px",
                          marginLeft: "24px",
                          marginRight: "4px",
                        }}
                        checked={partData.type === "part"}
                      />
                      Part
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="kind"
                        value="ncp"
                        id="ncp"
                        onChange={handleRadioBtnChange}
                        style={{
                          width: "12px",
                          height: "12px",
                          marginLeft: "24px",
                          marginRight: "4px",
                        }}
                        checked={partData.type === "ncp"}
                      />
                      NCP
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="kind"
                        value="np"
                        id="np"
                        onChange={handleRadioBtnChange}
                        style={{
                          width: "12px",
                          height: "12px",
                          marginLeft: "24px",
                          marginRight: "4px",
                        }}
                        checked={partData.type === "np"}
                      />
                      NP
                    </label>
                  </span>
                </label>
                {partData.type === "part" ? (
                  <div className={`flex pb-3"}`}>
                    <AsyncSelect
                      cacheOptions
                      className={`myreact-select-2 input-full`}
                      inputId="part"
                      name={"part"}
                      value={partData.part}
                      loadOptions={loadOptions}
                      onChange={handleSelectChange}
                      placeholder="Part"
                    />
                  </div>
                ) : (
                  <>
                    <div className="flex">
                      <input
                        type="text"
                        className="input input-full"
                        name={"part"}
                        value={partData?.part?.description || ""}
                        onChange={handleChange}
                        placeholder={
                          partData.type === "ncp"
                            ? "Enter Non Child Part Description"
                            : "Enter Non Part Description"
                        }
                      />
                    </div>
                  </>
                )}
                {errors.part && (
                  <p className="label-error-pos">{errors.part}</p>
                )}
              </Col>
            )}
            {type === "purchase" && (
              <Col md={5}>
                <label className="label" htmlFor="part">
                  {partData.type === "part" && <span>Part:</span>}
                  {partData.type === "np" && <span>Non Part:</span>}
                  <span
                    style={{
                      float: "right",
                      paddingRight: "4%",
                      fontWeight: "normal",
                    }}
                  >
                    <label>
                      <input
                        type="radio"
                        name="kind"
                        value="part"
                        id="part"
                        onChange={handleRadioBtnChange}
                        style={{
                          width: "12px",
                          height: "12px",
                          marginLeft: "24px",
                          marginRight: "4px",
                        }}
                        checked={partData.type === "part"}
                      />
                      Part
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="kind"
                        value="np"
                        id="np"
                        onChange={handleRadioBtnChange}
                        style={{
                          width: "12px",
                          height: "12px",
                          marginLeft: "24px",
                          marginRight: "4px",
                        }}
                        checked={partData.type === "np"}
                      />
                      NP
                    </label>
                  </span>
                </label>
                {partData.type === "part" ? (
                  <AsyncSelect
                    cacheOptions
                    className={`myreact-select-2 input-full`}
                    inputId="part"
                    name={"part"}
                    value={partData.part}
                    loadOptions={loadOptions}
                    onChange={handleSelectChange}
                    placeholder="Part"
                  />
                ) : (
                  <>
                    <div className="flex">
                      <input
                        type="text"
                        className="input input-full"
                        name={"part"}
                        value={partData?.part?.description || ""}
                        onChange={handleChange}
                        placeholder="Enter Non Part Description"
                      />
                    </div>
                  </>
                )}
                {errors.part && (
                  <p className="label-error-pos">{errors.part}</p>
                )}
              </Col>
            )}
            <Col md={2}>
              <DoubleField
                noGaps={true}
                label="Qty:"
                name="qty"
                value={partData.qty}
                onChange={handleChange}
                placeholder="Quantity"
                min="0"
                step="1.00"
                error={errors.qty}
              />
            </Col>
            <Col md={2}>
              <DoubleField
                noGaps={true}
                label="Price:"
                name="price"
                value={partData.price}
                onChange={handleChange}
                placeholder="Price"
                min="0"
                step="1.00"
                error={errors.price}
              />
            </Col>
            {type === "purchase" && (
              <Col md={2}>
                <label
                  className="label"
                  htmlFor="mfg"
                  style={{ fontSize: "14px" }}
                >
                  Mfg Name / PN:
                </label>
                <Select
                  cacheOptions
                  className={`myreact-select-2 input-full`}
                  inputId="mfg"
                  name="mfg"
                  value={partData.mfg}
                  options={partData.mfgOptions}
                  onChange={handleSelectChange}
                  placeholder="Mfg Name / PN"
                  isDisabled={partData.mfgOptions.length === 0}
                />
              </Col>
            )}
            <Col md={1}>
              <button
                className="sale-bal mt-4"
                type="button"
                style={{
                  backgroundColor: currentColor,
                  fontWeight: "1000",
                  fontSize: "18px",
                  color: "white",
                  width: "36px",
                  paddingTop: "4px",
                }}
                onClick={handleAddcartClick}
              >
                +
              </button>
            </Col>
          </Row>
          <Row className="container-col">
            <Col md={8} className="mt-1 right-table-field">
              <label className="pl-4">{partData.part?.last_so_info}</label>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default PosForm2;
